module.exports = __webpack_public_path__ + "media/images/shared/icon-identificationLegalParent-4fa6db54673929523b01c95d4613b972.png";